module.exports = __webpack_public_path__ + "img/a06.9b2a94a0.png";